export interface IRequestState {
  isRequestActive: boolean;
  errorDetails: IErrorDetails;
  isModelInvalid?: boolean;
}

export const initialRequestState: IRequestState = {
  isRequestActive: false,
  errorDetails: { statusCode: null, userMessage: null },
  isModelInvalid: false,
};

export interface IErrorModel {
  MessageId?: number;
  Field?: string;
  ErrorMsg?: string;
}

export interface IErrorDetails {
  userMessage: string | null;
  statusCode: number | null;
  errors?: IErrorModel[];
}

export function instanceOfIErrorDetails(object: any): object is IErrorDetails {
  return 'userMessage' in object && 'statusCode' in object;
}
